import React, { useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./SideMenu.css";
import { message } from "antd";
import IMAGES from "../../img/image";

const SideMenu = ({ sideMenu, setSideMenu }) => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const [submenu, setSubmenu] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    message.success("Logout Successful");
    navigate("/login");
  };
  return (
    <div
      className={`sidemenu-container d-block d-md-block d-lg-none ${sideMenu ? "active" : ""
        }`}
    >
      <div className="sidemenu">
        <HighlightOffIcon
          onClick={() => setSideMenu(!sideMenu)}
          className="close-icon"
        />
          <img src="/headerlogo.png" alt="logo" className="logo" />
        <ul className="p-0">
          <>
            <li>
              <Link onClick={() => setSideMenu(!sideMenu)} to="/track-order">
                Track Orders
              </Link>
            </li>
            <li>
              <Link onClick={() => setSideMenu(!sideMenu)} to="/contact">
                Contact Us
              </Link>
            </li>
            <li>
              <Link onClick={() => setSideMenu(!sideMenu)} to="https://api.whatsapp.com/send/?phone=919863052375&text&type=phone_number&app_absent=0">
                24/7 Chat Support
              </Link>
            </li>
          </>
          {user && (
            <li>
              <Link to="/user-dashboard">My Account</Link>
            </li>
          )}
          {!user && (
            <div>
              <div className="sidemenu-action-btn">
                <Link to="/login">Sign In</Link>
              </div>
              <div className="sidemenu-action-btn">
                <Link to="/register">Sign Up Its Free</Link>
              </div>
            </div>
          )}
          {user && (
            <div className="logout" onClick={handleLogout}>
              Logout
              <LogoutIcon className="icon" />
            </div>
          )}
        </ul>
      </div>
    </div>
  );
};

export default SideMenu;
